import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from './auth.service';

let loginNavigationStarted = false;

export const authRedirectInterceptor: HttpInterceptorFn = (request, next) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return next(request).pipe(
        catchError((error: unknown) => {
            if (
                error instanceof HttpErrorResponse &&
                error.status === 401 &&
                !loginNavigationStarted &&
                !router.url.startsWith('/login') &&
                shouldRedirectToLogin(request.url)
            ) {
                loginNavigationStarted = true;
                auth.invalidate();
                const redirectUri = router.url === '/' ? undefined : router.url;
                const loginUrl = router.serializeUrl(
                    router.createUrlTree(['/login'], { queryParams: { redirectUri } }),
                );
                window.location.assign(loginUrl);
            }

            return throwError(() => error);
        }),
    );
};

function shouldRedirectToLogin(value: string): boolean {
    const url = new URL(value, window.location.origin);
    return (
        url.origin === window.location.origin &&
        url.pathname.startsWith('/api/') &&
        !url.pathname.startsWith('/api/auth/')
    );
}
